import { append, includes, without } from 'ramda'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import CheckboxInput from '../../../../components/form/CheckboxInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../components/helpers/Separator'

const OPTIONS = [
  { value: 'non_compliance', labelKey: 'statusSourceConfig.nonCompliance' },
  { value: 'automation', labelKey: 'statusSourceConfig.automation' }
]

const StatusSourceCheckboxes = ({ value, onChange }) => {
  const { t } = useTranslation('availability')
  const values = value || []

  const toggle = optionValue => {
    const isChecked = includes(optionValue, values)
    onChange(isChecked ? without([optionValue], values) : append(optionValue, values))
  }

  return (
    <>
      {OPTIONS.map(option => (
        <Fragment key={option.value}>
          <CheckboxInput
            value={includes(option.value, values)}
            onChange={() => toggle(option.value)}
            label={t(option.labelKey)}
          />
          <Separator weight={3} />
        </Fragment>
      ))}
    </>
  )
}

const GeneralSection = () => <FormItem path={['value']} ignoreLabel Input={StatusSourceCheckboxes} />

export default GeneralSection
